import { AirtableRecordResponse } from "../airtable/types";
import { fetchAssetDetails } from "../FetchAssetDetails";
import { RailData } from "./types";

/**
 * Given a Collection from Airtable,
 * returns a RailData object with itself and an array of AssetResponses from ATOM
 * If "Asset Slugs" is not a valid field, returns assets as an empty array
 *
 * @param rail - AirtableRecordResponse for a given Collection from Airtable
 * @returns Promise that resolves to a RailData object with itself and either
 *          an array of AssetResponse from ATOM or an empty array
 */
const fetchRailData = async (
  rail: AirtableRecordResponse,
): Promise<RailData> => {
  if (
    "Asset Slugs" in rail.fields &&
    rail.fields["Asset Slugs"] !== undefined
  ) {
    const assets = await Promise.all(
      rail.fields["Asset Slugs"].map((identifier) =>
        fetchAssetDetails(identifier),
      ),
    );
    return { self: rail, assets };
  } else {
    return { self: rail, assets: [] };
  }
};

export { fetchRailData };
